export const TRANSLATION_LANGUAGES = [
  {
    label: 'Arabic',
    value: 'ar',
  },
  {
    label: 'Bulgarian',
    value: 'bg',
  },
  {
    label: 'Czech',
    value: 'cs',
  },
  {
    label: 'Danish',
    value: 'da',
  },
  {
    label: 'German',
    value: 'de',
  },
  {
    label: 'Greek',
    value: 'el',
  },
  {
    label: 'English',
    value: 'en',
  },
  {
    label: 'Spanish',
    value: 'es',
  },
  {
    label: 'Estonian',
    value: 'et',
  },
  {
    label: 'Finnish',
    value: 'fi',
  },
  {
    label: 'French',
    value: 'fr',
  },
  {
    label: 'Hungarian',
    value: 'hu',
  },
  {
    label: 'Indonesian',
    value: 'id',
  },
  {
    label: 'Italian',
    value: 'it',
  },
  {
    label: 'Japanese',
    value: 'ja',
  },
  {
    label: 'Korean',
    value: 'ko',
  },
  {
    label: 'Latvian',
    value: 'lv',
  },
  {
    label: 'Lithuanian',
    value: 'lt',
  },
  {
    label: 'Norwegian Bokmål',
    value: 'nb',
  },
  {
    label: 'Dutch',
    value: 'nl',
  },
  {
    label: 'Polish',
    value: 'pl',
  },
  {
    label: 'Portuguese',
    value: 'pt',
  },
  {
    label: 'Romanian',
    value: 'ro',
  },
  {
    label: 'Russian',
    value: 'ru',
  },
  {
    label: 'Slovak',
    value: 'sk',
  },
  {
    label: 'Slovenian',
    value: 'sl',
  },
  {
    label: 'Swedish',
    value: 'sv',
  },
  {
    label: 'Turkish',
    value: 'tr',
  },
  {
    label: 'Ukrainian',
    value: 'uk',
  },
  {
    label: 'Chinese (Simplified)',
    value: 'zh',
  },
  {
    label: 'Hebrew',
    value: 'he',
  },
  {
    label: 'Vietnamese',
    value: 'vi',
  },
  {
    label: 'Thai',
    value: 'th',
  },
];
